module.exports = __webpack_public_path__ + "img/Postmodernisme_Kari-Svendsen.c44522a4.jpg";